var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-img',{attrs:{"aspect-ratio":"1","src":`https://maps.googleapis.com/maps/api/staticmap?${_vm.mapParams(_vm.location)}&key=${_vm.apiKey}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }